import { Fragment, useState } from "react";
import { Link as RouterLink } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";
import {
  Box,
  Card,
  CardContent,
  Container,
  Divider,
  Link,
  Typography,
} from "@material-ui/core";
import LoginForm from "../../components/authentication/LoginForm";
import Logo from "../../components/general/Logo";

const SUBTITLES = {
  credentials: "Please enter your credentials",
  setup: "Please set up two-factor authentication",
  verify: "Please verify two-factor authentication",
};

const Login = () => {
  // States

  const [step, setStep] = useState("credentials");

  // Rendering

  return (
    <Fragment>
      <Helmet>
        <title>LeanAds | Login</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Container maxWidth="sm" sx={{ py: "80px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 8,
            }}
          >
            <Logo size={50} to="/" />
          </Box>
          <Card>
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 4,
              }}
            >
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 3,
                }}
              >
                <div>
                  <Typography color="textPrimary" gutterBottom variant="h4">
                    Log in
                  </Typography>
                  <Typography color="textSecondary" variant="body2">
                    {SUBTITLES[step]}
                  </Typography>
                </div>
              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                  mt: 3,
                }}
              >
                <LoginForm onStepChange={setStep} />
              </Box>
              <Divider sx={{ my: 3 }} />
              <Link
                color="textSecondary"
                component={RouterLink}
                to="/authentication/forgot-password"
                variant="body2"
              >
                Forgot password
              </Link>
              <Link
                color="textSecondary"
                sx={{ mt: 1 }}
                component={RouterLink}
                to="/authentication/signup"
                variant="body2"
              >
                I received an invitation
              </Link>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </Fragment>
  );
};

export default Login;
